import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=3051c4df&scoped=true&"
import script from "./MenuForm.vue?vue&type=script&lang=js&"
export * from "./MenuForm.vue?vue&type=script&lang=js&"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=3051c4df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051c4df",
  null
  
)

export default component.exports